import { Component, EventEmitter, Input, OnInit, Output, ViewChild, NgModule } from '@angular/core';
import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { StatusHelperService } from 'src/app/services/helpers/status-helper.service';
import { ProgramService } from 'src/app/services/program.service';
import { PromotionConfigService } from 'src/app/services/promotion-config.service';
import { PromotionService } from 'src/app/services/promotion.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { faPlus, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { ResponseHelperService } from 'src/app/services/helpers/response-helper.service';
import { ActivatedRoute } from '@angular/router';
import { PromotionTemplate } from 'src/app/data/model';
import { Promotion } from 'src/app/data/model';
import * as $ from 'jquery';
import {Observable, Subject} from 'rxjs';
import { RegexSearchModalComponent } from 'src/app/regex-search-modal/regex-search-modal.component';
import { fromEvent, interval } from 'rxjs';
import { debounce } from 'rxjs/operators';

@Component({
  selector: 'app-reward-transfer-consequence',
  templateUrl: './reward-transfer-consequence.component.html',
  styleUrls: ['./reward-transfer-consequence.component.scss']
})
export class RewardTransferConsequenceComponent implements OnInit {
    @Input() transferRewards: any;
    faTimes = faTimes;
    faPlus = faPlus;
    @Input() rewardTypes: any;
    periods: any;
    @Output() public inputChangeEmitter: EventEmitter<any> = new EventEmitter(true);
    debouncer: Subject<string> = new Subject<string>();

  constructor(
    private router: ActivatedRoute,
    private formBuilder: FormBuilder,
    private formsModule: FormsModule,
    private modalHelper: NgbModal
  ) {
      this.debouncer
        .pipe(debounce(() => interval(1000)))
        .subscribe((value) => this.inputChangeEmitter.emit(value));
    }

  ngOnInit(): void {
      this.periods = [
        {'value' : 'CAMPAIGN',     'text': 'CAMPAIGN'},
        {'value' : 'YEAR',     'text': 'YEAR'},
        {'value' : 'QUARTER',     'text': 'QUARTER'},
        {'value' : 'MONTH',    'text': 'MONTH'},
        {'value' : 'WEEK',     'text': 'WEEK'},
        {'value' : 'DAY',    'text': 'DAY'},
        {'value' : 'CUSTOM',    'text': 'CUSTOM'}
      ];
  }

  regexSearchModal(searchFor: string, item: any, size: string, limitToOne: boolean, setValue: boolean, itemIndex: number): void {
    this.openRegexSearchModal(searchFor, item, size, limitToOne, setValue, itemIndex);
  }

  openRegexSearchModal(searchFor: string, item: any, size: string, limitToOne: boolean, setValue: boolean, itemIndex: number): void {
    const instance = this.modalHelper.open(RegexSearchModalComponent);
    instance.componentInstance.searchFor = searchFor;
    instance.componentInstance.item = item;
    instance.componentInstance.size = size;
    instance.componentInstance.limitToOne = limitToOne;
    instance.componentInstance.setValue = setValue;
    instance.componentInstance.itemIndex = itemIndex;
    instance.componentInstance.successEvent.subscribe((text: any) => {
      this.transferRewards[itemIndex][item.name] = text;
      this.updateConsequences();
      instance.close();
    });
  }

  initConsequenceObject(): void {
    console.log(this.transferRewards);
    var tmpObj = { class: "com.chiprewards.cheetah.business.rules.config.behavior.v2.BehaviorConfiguration$Consequences$TransferRewards"};
    if(this.transferRewards){
      this.transferRewards.push(tmpObj);
    } else {
      this.transferRewards = [];
      this.transferRewards.push(tmpObj);
    }
    console.log(this.transferRewards);
  }

  updateConsequences() {
    this.debouncer.next(this.transferRewards);
  }

  removeConsequence(consequence) {
    this.transferRewards.splice(this.transferRewards.indexOf(consequence), 1);
    this.updateConsequences();
  }
}
